import axios from "axios";
import { alertMessages, stationQuery, weatherObsQuery, weatherObsStationsQuery, wxMinMaxQuery,stationInformationQuery, outageBannerAllUsers, stationQueryMap, getNfdrWithoutTimeQuery, nfdrHourlyQuery, getClimatologyCodeTable, stationTableQuery, nfdrCatalogQuery } from "src/constants";
import { checkAdminRole, errorResponse } from "src/store/common";
import { AllStations } from "src/types";
import { configMutationClimatology } from "./mutationsApiKey";
export const graphQLClientClimatology = axios.create({
  baseURL: `${process.env.REACT_APP_GRAPHQL_URL}`,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': `${process.env.REACT_APP_GRAPHQL_URL}`.split("/graphql", 1)[0]
  }
});

// export const graphQLClimatologyMutation = 
export const configurationClimatology = (data: string) => {
    return {
        method: 'post',
        url: `${process.env.REACT_APP_GRAPHQL_URL}`,
        headers: { 
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': `${process.env.REACT_APP_GRAPHQL_URL}`.split("/graphql", 1)[0]
        },
        data : data
    }
};
export const transformStationResponse = (data:any):AllStations =>{
	return{
    stations: data.map((station:any)=>({
      ...station,
      station_id: station.station_id,
      station_name: station.station_name?.toLowerCase(),
      wrcc_id: station.wrcc_id,
      search_name: station.station_name +", " + station.network_name+", " + station.state + ", " + station.station_id,
      elevation: station.elevation,      
      longitude: station.longitude,
      latitude: station.latitude,
      state: station.state
    }))
  };
};

/*call for station meta for a singular station*/
export const getStationMeta = async(request:any, addAlert: any, user?: any)=>{
    try{
        let stationData = JSON.stringify({
            query: stationInformationQuery,
            variables: {
                stationId: request.stationId,
                stationType: request.stationType,
                hasHistoricData: 'ALL',
                stationMetadataVisible: 'ALL'			
            }
        });
        let config = checkAdminRole(user) && user ? configMutationClimatology(stationData): configurationClimatology(stationData);
        return(
            new Promise(function(resolve,reject){
                axios(config)
                .then(function(response: any){
                  
                  if(response.data.errors && response.data.errors.length > 0){
                    return reject(new Error(response.data.errors));
                  }else{
                    const stationMetaDataResponse = response.data.data.stationMetaData.data[0];
                    return resolve(stationMetaDataResponse)
                  }
                
                })
                .catch(function (error: any) {
                    if(error.response?.data.errors[0].message.includes('famauth')){
                        return reject(new Error(error))
                    }else{
                        errorResponse(error, addAlert, alertMessages.retrievingStationData);
                        return reject(new Error(error))
                    }
                });
            })
          );

    }
    catch(error){
        console.log('error', error);

    }
};

/*call for Nfdr Catalo */
export const getNfdrCatalog =async(request:any, addAlert: any)=>{
    try{
        let stationData = JSON.stringify({
            query: nfdrCatalogQuery,
            variables: {
                stationId: request.stationId					
            }
        });
        let config = configurationClimatology(stationData);
        return(
            new Promise(function(resolve,reject){
                axios(config)
                .then(function(response: any){
                  
                  if(response.data.errors && response.data.errors.length > 0){
                    return reject(new Error(response.data.errors));
                  }else{
                    const stationMetaDataResponse = response.data.data.nfdrCatalog.data;
                    return resolve(stationMetaDataResponse)
                  }
                
                })
                .catch(function (error: Error) {
                    errorResponse(error, addAlert, alertMessages.retrievingStationData);
                    return reject(error)
                });
            })
          );

    }
    catch(error){
        console.log('error', error);

    }
};

/* stations will be transformed to have search name for search bars*/
export const getStations = async(request:any, addAlert: any, user?:any) =>{
    try{
        let dataStations = JSON.stringify({
            query: stationQuery,
            variables: {
                stationId: request.stationId,
                stationType: request.type,
                returnAll: request.returnAll,
                hasHistoricData: 'ALL',
                stationMetadataVisible: 'ALL',
                weatherDailyVisible: request?.weatherDailyVisible,
                nfdrsDailyVisible: request?.nfdrsDailyVisible,
                weatherHourlyVisible: request?.weatherHourlyVisible,
                nfdrsHourlyVisible: request?.nfdrsHourlyVisible,
                weatherDailyDownload: request?.weatherDailyDownload,
                weatherHourlyDownload: request?.weatherHourlyDownload,
                nfdrsDailyDownload: request?.nfdrsDailyDownload,
                nfdrsHourlyDownload: request?.nfdrsHourlyDownload,
                produceNfdrs: request?.produceNfdrs,
                ingestObservation: request?.ingestObservation
            }
        });
        let config = checkAdminRole(user) && user ? configMutationClimatology(dataStations) : configurationClimatology(dataStations);
        return(
            new Promise(function(resolve, reject){
                axios(config)
                .then(function(response:any){
                    if(response.data.errors && response.data.errors.length > 0){
                        return reject(new Error(response.data.errors));
                    }else{
                        const allStations = transformStationResponse(response.data.data.stationMetaData.data);
                        return resolve(allStations);
                    }
                })
                .catch(function (error: any) {
                    if(error.response?.data.errors[0].message.includes('famauth')){
                        return reject(new Error(error))
                    }else{
                        errorResponse(error, addAlert, alertMessages.retrievingStationData);
                        return reject(new Error(error))
                    }
                });
            })
        )
    }
    catch(error){
        console.log('error', error);

    }
};

export const getStationTable = async(request:any, addAlert: any, user?: any) =>{
    try{
        let dataStations = JSON.stringify({
            query: stationTableQuery,
            variables: {
                stationId: request.stationId,
                networkName: request.networkName,
                stateId: request.stateId,
                agency: request.agency,
                sortBy: request.sortBy, 
                sortOrder: request.sortOrder,
                page: request.page,
                perPage: request.perPage,
                hasHistoricData: 'ALL',
                stationMetadataVisible: 'ALL'
            }
        });
        let config = checkAdminRole(user) && user ? configMutationClimatology(dataStations) : configurationClimatology(dataStations);
        return(
            new Promise(function(resolve, reject){
                axios(config)
                .then(function(response:any){
                    if(response.data.errors && response.data.errors.length > 0){
                        return reject(new Error(response.data.errors));
                    }else{
                        return resolve(response.data.data.stationMetaData);
                    }
                })
                .catch(function (error: any) {
                    console.log('error', error)
                    if(error.response?.data.errors[0].message.includes('famauth')){
                        return reject(new Error(error))
                    }else{
                        errorResponse(error, addAlert, alertMessages.retrievingStationData);
                        return reject(new Error(error))
                    }
                });
            })
        )
    }
    catch(error){
        console.log('error', error);

    }
};

/*stations for map*/
export const getStationsMap= async(request:any, type:string, user?: any) =>{
    try{
        let dataStations = JSON.stringify({
            query: stationQueryMap,
            variables: {
                stationType: request.type,
                returnAll: request.returnAll,
                zoomLevel: request.zoomLevel,
                hasHistoricData: 'ALL',
                stationMetadataVisible: 'ALL',
                weatherDailyVisible: request?.weatherDailyVisible,
                nfdrsDailyVisible: request?.nfdrsDailyVisible, 
                weatherHourlyVisible: request?.weatherHourlyVisible, 
                nfdrsHourlyVisible: request?.nfdrsHourlyVisible, 
                weatherDailyDownload: request?.weatherDailyDownload, 
                weatherHourlyDownload: request?.weatherHourlyDownload, 
                nfdrsDailyDownload: request?.nfdrsDailyDownload, 
                nfdrsHourlyDownload: request?.nfdrsHourlyDownload, 
                produceNfdrs: request?.produceNfdrs, 
                ingestObservation: request?.ingestObservation,
            }
        });
        let configStationInfo = checkAdminRole(user) && user ? configMutationClimatology(dataStations):configurationClimatology(dataStations);
        let dataWeatherHourly = JSON.stringify({
            query: weatherObsQuery,
            variables: {
                zoomLevel: request.zoomLevel,
                startDate: request.startDate,
                endDate: request.endDate,
                timeZone: request.timeZone,
                stationType: request.stationType,
                hasHistoricData: 'ALL',
                visibilitySettings: 'ALL'		
            }
        });
        let configWxObs = configurationClimatology(dataWeatherHourly);
        let dataWeatherMinMax = JSON.stringify({
            query: wxMinMaxQuery,
            variables: {
                zoomLevel: request.zoomLevel,
                startDate: request.startDate,
                endDate: request.endDate,
                stationIds: request.stationIds,
                hasHistoricData: 'ALL',
                visibilitySettings: 'ALL'
            }
        });
        let configWxMinMax = configurationClimatology(dataWeatherMinMax);
        let dataNfdrsObs = JSON.stringify({
            query: nfdrHourlyQuery,
            variables: {
                zoomLevel: request.zoomLevel,
                startDateRange: request.startDate,
                endDateRange: request.endDate,
                startHour: Number(request.startHour),
                endHour: Number(request.endHour),
                stationIds: request.stationIds,
                page: request.page,
                per_page: request.perPage,
                fuelModel: request.fuelModel,
                nfdrType: 'appended',
                hasHistoricData: 'ALL',
                visibilitySettings: 'ALL'
            }
        });
        let configNfdrHourly = configurationClimatology(dataNfdrsObs);
        let dataNfdrMinMax = JSON.stringify({
            query: getNfdrWithoutTimeQuery,
            variables: {
                zoomLevel: request.zoomLevel,
                startDate: request.startDate,
                endDate: request.endDate,
                stationIds: request.stationIds,
                page: request.page,
                per_page: request.perPage,
                fuelModel: request.fuelModel,
                hasHistoricData: 'ALL',
                visibilitySettings: 'ALL'

            }
        });
        let configNfdrMinMax = configurationClimatology(dataNfdrMinMax);
        if(type==='hourlyWx'){
            const [responseStations, wxHourly] = await Promise.all([
                axios(configStationInfo),
                axios(configWxObs)
            ])
            return {stations: responseStations.data.data.stationMetaData.data, obs: wxHourly.data.data.weatherObs.data}
        }
        if(type==='dailyWx'){
            const [responseStations, responseMinMaxWX] = await Promise.all([
                axios(configStationInfo),
                axios(configWxMinMax)
            ]);
            return {stations: responseStations.data.data.stationMetaData.data, obs: responseMinMaxWX.data.data.wxMinMax.data}
        }
        if(type==='hourlyNfdr'){
            const [responseStations, nfdrsObs] = await Promise.all([
                axios(configStationInfo),
                axios(configNfdrHourly)
            ])
            return {stations: responseStations.data.data.stationMetaData.data, obs: nfdrsObs.data.data.nfdrsObs.data}
        }
        if(type==='dailyNfdr'){
            const [responseStations, responseNfdrMinMax] = await Promise.all([
                axios(configStationInfo),
                axios(configNfdrMinMax)
            ]);
            return {stations: responseStations.data.data.stationMetaData.data, obs: responseNfdrMinMax.data.data.nfdrMinMax.data}
        }
        
    }
    catch(error){
        console.log('error', error);

    }
};

export const getWeatherObsStations =async(request:any, addAlert: any)=>{
    try{
        let dataWeatherHourly = JSON.stringify({
            query: weatherObsStationsQuery,
            variables: {
                stationId: request.stationId,
                zoomLevel: request.zoomLevel,
                startDate: request.startDate,
                endDate: request.endDate,
                timeZone: request.timeZone,
                stationType: request.stationType,
                hasHistoricData: 'ALL',
                page: request.page,
                perPage: request.perPage,
                sortBy: request.sortBy,
                sortOrder: request.sortOrder,
                visibilitySettings: 'ALL'
            }
        });
        let config = configurationClimatology(dataWeatherHourly);
        return(
            new Promise(function(resolve,reject){
                axios(config)
                .then(function(response: any){
                  
                  if(response.data.errors && response.data.errors.length > 0){
                    return reject(new Error(response.data.errors));
                  }else{
                    const weatherObs = response.data.data.weatherObs;
                    return resolve(weatherObs)
                  }
                
                })
                .catch(function (error: any) {
                    if(error.response?.data.errors[0].message.includes('famauth')){
                        return reject(new Error(error))
                    }else{
                        errorResponse(error, addAlert, alertMessages.retrievingStationData);
                        return reject(new Error(error))
                    }
                });
            })
          );

    }
    catch(error){
        console.log('error', error);

    }
};

export const getWeatherObsAllStations =async(request:any, addAlert: any)=>{
    try{
        let dataWeatherHourly = JSON.stringify({
            query: weatherObsQuery,
            variables: {
                zoomLevel: request.zoomLevel,
                startDate: request.startDate,
                endDate: request.endDate,
                stationType: request.stationType,
                hasHistoricData: 'ALL',
                visibilitySettings: 'ALL'		
            }
        });
        let config = configurationClimatology(dataWeatherHourly);
        return(
            new Promise(function(resolve,reject){
                axios(config)
                .then(function(response: any){
                  
                  if(response.data.errors && response.data.errors.length > 0){
                    return reject(new Error(response.data.errors));
                  }else{
                    const weatherObs = response.data.data.weatherObs.data;
                    return resolve(weatherObs)
                  }
                
                })
                .catch(function (error: any) {
                    console.log('error', error);
                    errorResponse(error, addAlert, alertMessages.retrievingStationData);

                    return reject(new Error(error))
                });
            })
          );

    }
    catch(error){
        console.log('error', error);

    }
};

export const getWeatherMinMax = async(request:any, addAlert: any, user?:any)=>{
    try{
        let dataWeatherMinMax = JSON.stringify({
            query: wxMinMaxQuery,
            variables: {
                zoomLevel: request.zoomLevel,
                startDate: request.startDate,
                endDate: request.endDate,
                stationIds: request.stationIds,
                hasHistoricData: 'ALL',
                page: request.page,
                perPage: request.perPage,
                sortBy: request.sortBy,
                sortOrder: request.sortOrder,
                visibilitySettings: 'ALL'
            }
        });
        let config =checkAdminRole(user) && user? configMutationClimatology(dataWeatherMinMax): configurationClimatology(dataWeatherMinMax);
        return(
            new Promise(function(resolve,reject){
                axios(config)
                .then(function(response: any){
                  if(response.data.errors && response.data.errors.length > 0){
                    return reject(new Error(response.data.errors));
                  }else{
                    const wxMinMax = response.data.data.wxMinMax;
                    return resolve(wxMinMax);
                  }
                
                })
                .catch(function (error: any) {
                    if(error.response?.data.errors[0].message.includes('famauth')){
                        return reject(new Error(error))
                    }else{
                        errorResponse(error, addAlert, alertMessages.retrievingStationData);
                        return reject(new Error(error))
                    }
                });
            })
          );

    }
    catch(error){
        console.log('error', error);

    }
};

export const checkBannerOutage = async(addAlert: any)=>{
    try{
        let dataforBanner = JSON.stringify({
            query: outageBannerAllUsers,

          });
        let config = configurationClimatology(dataforBanner);
        return(
            new Promise(function(resolve,reject){
                axios(config)
                .then(function(response: any){
                    if(response.data.errors && response.data.errors.length > 0){
                        return reject(new Error(response.data.errors));
                    }
                    else{
                        return resolve(response.data.data.notification.data)
                    }
                
                })
                .catch(function (error: any) {
                    errorResponse(error, addAlert, alertMessages.retrievingStationData);

                    return reject(new Error(error))
                });
            })
          );

    }
    catch(error){
        console.log('error', error);

    }
};

/* get codes will get the codes for the dropdowns*/
export const getClimatologyCodeTables =async (requestVars: any) => {
    let responseFromCode: {
    fuelModel: [],
    networkId: [],
    agency: [],
    stateId: [],
    wxsource: []
    } = {
        fuelModel: [],
        networkId: [],
        agency: [],
        stateId: [],
        wxsource: []
    };
    try {
      let data = JSON.stringify({
        query: getClimatologyCodeTable,
        variables:{
          returnAll: requestVars.returnAll,
          type:requestVars.type
        }
      });
      let config = configurationClimatology(data);
      return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(function(response: any){
              
              if(response.data.errors && response.data.errors.length > 0) {
                return reject(new Error(response.data.errors));
              } else {
                const allCodes = response.data.data.codeTable.data;
                if(allCodes){
                  if(requestVars.returnAll===true){
                    const fuelModels = allCodes.filter((code:any) => code.type === 'fuel_models.fuel_model');
                    const networkId = allCodes.filter((code:any) => code.type === 'network_id');
                    const agency = allCodes.filter((code:any) => code.type === 'station_information.agency');
                    const stateId = allCodes.filter((code:any) => code.type === 'station_information.state_id');
                    const wxsource = allCodes.filter((code:any) => code.type === 'wxsource');

                    responseFromCode = {
                        fuelModel: fuelModels,
                        networkId: networkId,
                        agency: agency,
                        stateId: stateId,
                        wxsource: wxsource,
                    }
                    
                    return resolve(responseFromCode)
                }
                else {
                    return resolve(allCodes)
                }
              }
            }
            })
            .catch(function (error: any) {
                console.log('error', error);
                return reject(new Error(error))
            });
        })
      );
    }
    catch (error) {
      console.log('error', error);

    }
}